module.exports = fox._r("components/valentines-gifts-popup/images/title-bg-v.png", __webpack_public_path__ + "_/_/_/root/components/valentines-gifts-popup/images/title-bg-v.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/valentines-gifts-popup/images/title-bg-v.png
// module id = 728
// module chunks = 4